import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import "./Button.css";
import "./ExpandableButton.css";
import * as React from "react";
import { Button } from "./Button";
import { Expandable } from '../../Expandable';
import { Icon } from '../../Icon';
import { css } from '../../Util';
var buttonId = 1;
var ExpandableButton = /** @class */ (function (_super) {
    tslib_1.__extends(ExpandableButton, _super);
    function ExpandableButton(props) {
        var _this = _super.call(this, props) || this;
        _this.buttonElement = React.createRef();
        _this.containerElement = React.createRef();
        _this.expandable = React.createRef();
        _this.collapse = function () {
            if (_this.expandable.current) {
                _this.expandable.current.collapse();
            }
        };
        _this.expand = function () {
            if (_this.expandable.current) {
                _this.expandable.current.expand();
            }
        };
        _this.renderCallout = function () {
            return _this.props.renderCallout(_this, _this.dropdownId, _this.props.anchorElement
                ? _this.props.anchorElement
                : !_this.props.anchorPoint
                    ? _this.containerElement.current
                        ? _this.containerElement.current
                        : undefined
                    : undefined, _this.props.anchorOffset || { horizontal: 0, vertical: 0 }, _this.props.anchorOrigin || { horizontal: "end" /* end */, vertical: "end" /* end */ }, _this.props.anchorPoint, _this.props.dropdownOrigin || { horizontal: "end" /* end */, vertical: "start" /* start */ });
        };
        _this.dropdownId = props.dropdownId || "dropdown-" + buttonId++;
        return _this;
    }
    ExpandableButton.prototype.render = function () {
        var _this = this;
        // We disable the tooltip when we are expanded. Make sure we dont remove it
        // from the component tree, this causes the button element to get regenerated
        // and focus wont return.
        return (React.createElement(Expandable, { disabled: this.props.disabled, expandKey: this.props.expandKey, onCollapse: this.props.onCollapse, onExpand: this.props.onExpand, renderCallout: this.renderCallout, ref: this.expandable }, function (expandableProps) {
            return (React.createElement("div", { className: "bolt-expandable-button", onMouseDown: expandableProps.onMouseDown, onKeyDown: expandableProps.onKeyDown, ref: _this.containerElement },
                React.createElement(Button, tslib_1.__assign({}, _this.props, { ariaControls: expandableProps.expanded ? _this.dropdownId : undefined, ariaExpanded: expandableProps.expanded, ariaHasPopup: true, className: css(_this.props.className, !_this.props.text && !_this.props.children && _this.props.iconProps && "icon-only", expandableProps.expanded && "active"), onClick: expandableProps.onClick, ref: _this.buttonElement, tooltipProps: _this.props.tooltipProps ? tslib_1.__assign({}, _this.props.tooltipProps, { disabled: expandableProps.expanded }) : undefined }),
                    _this.props.children,
                    !_this.props.hideDropdownIcon
                        ? Icon({ key: "dropdown-icon", className: "icon-right", iconName: "ChevronDownMed" })
                        : undefined)));
        }));
    };
    ExpandableButton.prototype.focus = function () {
        if (this.buttonElement.current) {
            this.buttonElement.current.focus();
        }
    };
    ExpandableButton.defaultProps = {
        expandKey: [40 /* downArrow */, 13 /* enter */]
    };
    return ExpandableButton;
}(React.Component));
export { ExpandableButton };
